/**
 * @generated SignedSource<<f702ecbf614582ee2f1fac34f4546b2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcquireReportLockInput = {
  reportId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type AcquireReportLockMutation$variables = {
  input: AcquireReportLockInput;
};
export type AcquireReportLockMutation$data = {
  readonly acquireReportLock: {
    readonly token: string | null;
    readonly locked: boolean | null;
    readonly heldByViewer: boolean | null;
    readonly holder: {
      readonly id: string;
      readonly fullName: string | null;
      readonly profilePictureId: string | null;
    } | null;
    readonly lockedAt: string | null;
    readonly expiresAt: string | null;
  } | null;
};
export type AcquireReportLockMutation = {
  variables: AcquireReportLockMutation$variables;
  response: AcquireReportLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcquireReportLockPayload",
    "kind": "LinkedField",
    "name": "acquireReportLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heldByViewer",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "holder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profilePictureId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lockedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcquireReportLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcquireReportLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9d91a8f091b05c3686027e8543daec8",
    "id": null,
    "metadata": {},
    "name": "AcquireReportLockMutation",
    "operationKind": "mutation",
    "text": "mutation AcquireReportLockMutation(\n  $input: AcquireReportLockInput!\n) {\n  acquireReportLock(input: $input) {\n    token\n    locked\n    heldByViewer\n    holder {\n      id\n      fullName\n      profilePictureId\n    }\n    lockedAt\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9e1829ff41f1c9fcbbf23597a20f312";

export default node;
